import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#BCE4FF" rx={6.4} />
    <path
      fill="#0E0F10"
      fillOpacity={0.05}
      d="M25.6 0A6.4 6.4 0 0 1 32 6.4v3.2a6.4 6.4 0 0 0-6.4-6.4H6.4A6.4 6.4 0 0 0 0 9.6V6.4A6.4 6.4 0 0 1 6.4 0z"
    />
    <path
      fill="#D3DBE2"
      d="M25.6 0A6.4 6.4 0 0 1 32 6.4v19.2a6.4 6.4 0 0 1-6.4 6.4H6.4A6.4 6.4 0 0 1 0 25.6V6.4A6.4 6.4 0 0 1 6.4 0zM6.4 1.6c-2.65 0-4.8 2.15-4.8 4.8v19.2c0 2.65 2.15 4.8 4.8 4.8h19.2c2.65 0 4.8-2.15 4.8-4.8V6.4c0-2.65-2.15-4.8-4.8-4.8z"
    />
    <path
      fill="#0763FB"
      d="M23.834 10.234a.8.8 0 0 1 1.198 1.056l-.067.076-11.2 11.2a.8.8 0 0 1-1.056.066l-.075-.067-5.6-5.6a.8.8 0 0 1 1.056-1.197l.075.066 5.034 5.034z"
    />
  </svg>
);
const SvgIconCheckboxSelectedHover = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCheckboxSelectedHover);
export default Memo;
